import type { CardActivityEvent } from '../cards.types';

export const activityFixture: CardActivityEvent[] = [
  {
    id: 'act-1',
    cardId: 'card-eur-main-9374',
    at: '2025-07-24T03:12:00Z',
    kind: 'limit_changed',
    actor: 'Anna Smith',
    detail: 'Daily limit increased to €2.000',
  },
  {
    id: 'act-2',
    cardId: 'card-eur-main-9374',
    at: '2025-07-23T03:12:00Z',
    kind: 'pin_reset',
    actor: 'Maryna Alasania',
    detail: 'New PIN sent to cardholder by SMS',
  },
  {
    id: 'act-3',
    cardId: 'card-eur-main-9374',
    at: '2025-07-22T03:12:00Z',
    kind: 'created',
    actor: 'Diego Rodrigez',
    detail: 'Virtual debit card issued',
  },
  {
    id: 'act-4',
    cardId: 'card-gbp-main-6671',
    at: '2025-07-21T03:12:00Z',
    kind: 'blocked',
    actor: 'Maryna Alasania',
    detail: 'Travel 8829',
  },
  {
    id: 'act-5',
    cardId: 'card-eur-business-8829',
    at: '2025-07-20T03:12:00Z',
    kind: 'activated',
    actor: 'Maximilian Dwayn',
    detail: 'Physical card activated',
  },
];
